module.exports = __webpack_public_path__ + "static/media/mountain-salym.9a10efb3.jpg";